import { initialiseContactList, createContactMarkup, topLevelContactList, updateContactList } from "./contactsView.js";

export const nameAddInput = document.querySelector('#name-add');
export const emailAddInput = document.querySelector('#email-add');
export const addContactSaveButton = document.querySelector('#add-contact-save');
export const addContactCloseButton = document.querySelector('#add-contact-close');
// export const addContactPopover = document.querySelector('#add-contact-popover');
// export const scannerPopover = document.querySelector('#scanner-popover');
export const downloadListButton = document.querySelector('#download-contacts');
export const addNewBtn = document.querySelector('#add-new');
export const manualAdd = document.querySelector('#manual-add');

export function setupContactEls() {

    initialiseContactList();

    addNewBtn.addEventListener('click', addNew);

    addContactSaveButton.addEventListener('click', addContact);
    addContactCloseButton.addEventListener('click', closeNew);

    downloadListButton.addEventListener('click', handleListDownload);
    if (!topLevelContactList || topLevelContactList.list.length === 0) {
        downloadListButton.setAttribute('disabled', true);
    }
}

function addNew() {

    manualAdd.classList.toggle('d-none');

}

function closeNew() {
    manualAdd.classList.add('d-none');
}

function addContact() {
    const contactObject = {};
    contactObject.name = nameAddInput.value;
    contactObject.email = emailAddInput.value;

    topLevelContactList.list.push(contactObject);
    updateContactList();

    nameAddInput.value = null;
    emailAddInput.value = null;

    closeNew();
}

function handleListDownload() {
    let text = `Name,Email,`;

    topLevelContactList.list.forEach((contact) => {

        text += `\n`;
        text += `${contact.name},`;
        text += `${contact.email},`;
    })


    const newFile = new Blob([text], { type: 'text/csv' });
    downloadListButton.download = 'AIRAH-scanner-export';
    downloadListButton.href = URL.createObjectURL(newFile);
}